import { render, staticRenderFns } from "./AddingNewWorkSchedule.vue?vue&type=template&id=671219df&scoped=true"
import script from "./AddingNewWorkSchedule.vue?vue&type=script&lang=js"
export * from "./AddingNewWorkSchedule.vue?vue&type=script&lang=js"
import style0 from "./AddingNewWorkSchedule.vue?vue&type=style&index=0&id=671219df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671219df",
  null
  
)

export default component.exports